import { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
} from 'chart.js';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { hideLoader, showLoader } from '../../Redux/Slice/Loader/loaderSlice';
import { HandleApiError } from '../../Utils/CommonErrors/HandleApiError';
import DashboardStatsService from "../../Services/DashboardStats/DashbordStatsService"

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);// Register ChartJS modules

const TopInspectors = ({ status, filterType, fromDate, toDate ,option}) => {
    const dispatch = useDispatch()
    const token = useSelector((state) => state.auth.user.data.body.data.token)

    const [result, setResult] = useState([])

    // top inspectors
    const getTopInspectors = async () => {
        dispatch(showLoader())
        const params = {
            status: status,
            filterType: filterType,
            startDate: fromDate,
            endDate: toDate
        }
        try {
            const response = await DashboardStatsService.getTopInspectors(
                params, token
            )

            if (response?.data?.statusCode == 200) {
                const data = response.data.body.data.summary || []

                const countMap = {};
                data.forEach(item => {
                    countMap[item.first_name] = item.total;
                });
                setResult(data)
            }
        } catch (error) {
            HandleApiError(error)
        } finally {
            dispatch(hideLoader())
        }
    }

    // setting lables to the graphs
    const MAX_BARS = 10;
    let labels = result.map(item => `${item.first_name} ${item.last_name}`)
    let dataValues = result.map(item => item.total)
    if (labels.length < MAX_BARS) {
        const remaining = MAX_BARS - labels.length;
        labels = [...labels, ...Array(remaining).fill('')];
        dataValues = [...dataValues, ...Array(remaining).fill(0)];
    }

    // patch data 
    const data = {
        labels,
        datasets: [
            {
                label: 'Total Inspections',
                data: dataValues,
                backgroundColor: '#B6D79B',
                borderRadius: 5,
            },
        ],
    };

    useEffect(() => {
        getTopInspectors()
    }, [status, filterType, fromDate, toDate])

    return (
        <Bar data={data} options={option} />
    )
}

export default TopInspectors